import React, { useState } from "react";
import "./PopupContainer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

const PopupContainer = props => {
  const [exit, setExit] = useState(false);
  const doExit = () => {
    setExit(true);
    setTimeout(() => {
      props.onExit();
    }, 500);
  };

  return (
    <div className={exit ? "popupCover exit" : "popupCover"} onClick={doExit}>
      <FontAwesomeIcon icon={faTimesCircle} className="closeButton" />
      <div className="popupContainer">
        <article className="popupContent">{props.children}</article>
      </div>
    </div>
  );
};

export default PopupContainer;



// WEBPACK FOOTER //
// ./src/components/PopupContainer.jsx